import { z } from 'zod'
import assert from 'assert'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const InterfaceIDPropsSchema = z.object({
  interfaceIDValue: z.instanceof(HexNumber),
})

export type InterfaceIDProps = z.infer<typeof InterfaceIDPropsSchema>

export class InterfaceID extends ValueObject<InterfaceIDProps> {
  /**
   * @returns the hex reprensentation of the interface ID
   */
  public getValue(): HexNumber {
    return this.props.interfaceIDValue
  }

  public static create(props: InterfaceIDProps): InterfaceID {
    const validatedProps = InterfaceIDPropsSchema.parse(props)
    assert(
      validatedProps.interfaceIDValue.getByteLength() === 4,
      'interfaceIDValue must be 4 bytes long'
    )
    return new InterfaceID(validatedProps)
  }
}
